<template>
  <div>
    <pc-navbar/>
    <div class="orderCreate" v-if="newsData.price">
      <!-- <div class="topbanner" :style="{background: `url(https://files.wondercv.com/pc/mentor/orders_header_${formData.plan}.jpg) no-repeat center`,
    backgroundSize: 'cover'}"></div> -->
      <div class="content clearfix">
        <div class="w840 fl">

          <div class="formBox bg_fff">
            <!-- <div class="pageTitle text_center f_28 color_40 font_w_b">{{planType[formData.plan].title}}</div> -->

            <div class="service">

              <!-- 1 选择服务内容 -->
              <div class="serviceTitle pr">
                <span class="f_18 color_40 font_w_b">选择服务内容</span>
                <div class="pa color_fff f_18 text_center">1</div>
              </div>
              
              <!-- 新 -->
              <div class="service-container">
                <div class="m-t-32 m-b-12">
                  <img v-if="serviceBanner && serviceBanner.image" @click="serviceBannerClick" class="banner-icon" :src="serviceBanner.image" alt="">
                  <div class="service-box" :class="{intern:formData.plan=='intern'}">
                  
                  <div class="service-item" v-for="(item,index) in orderService[formData.plan+'Service']" :key="`service-item&${index}`" @click="toggleService(item.type)">
                    <div class="service-item-header">
                      <h6>
                        {{ item.title }}
                          <img v-if="item.iconSrc" :src="item.iconSrc" alt="">
                      </h6>
                      <div class="service-item-detail">
                        详情
                        <p class="service-item-tips">{{ item.descTips }}</p>
                      </div>
                    </div>
                    
                    <p class="service-item-desc">{{ item.desc }}</p>
                    
                    <div class="service-item-footer">

                      <div class="service-item-footer-left">
                        <img :src="item.imgSrc" alt="">
                        <span>{{item.count}}用户选择</span>
                      </div>

                      <div class="service-item-footer-button" :class="formData[item.type] ? 'selected' : 'no-select'">
                        <i v-if="!formData[item.type] " class="iconfont iconxinjianjianli"></i>
                        {{ formData[item.type] ? '已选择' : '选择' }}
                      </div>

                    </div>

                  </div>

                </div>
                </div>

              </div>

              <!-- 旧 -->
              <!-- <div class="serviceList">
                <div class="item flex-c" v-for="(item,index) in orderService[formData.plan+'Service']" :key="index">
                  <div class="title f_16 color_40 font_w_b">{{item.title}}</div>
                  <div class="desc f_14 color_9c flex1">{{item.desc}}</div>
                  <div class="tips pr">
                    <div class="tipsButton text_center f_14 color_9c cursor_p">详情</div>
                    <div class="tipsText pa color_fff f_12">{{item.descTips}}</div>
                  </div>
                  <div class="checked color_fff text_center cursor_p f_14" v-if="formData[item.type]"
                       @click="toggleService(item.type)">已选择
                  </div>
                  <div class="check iconfont iconplus color_9c font_w_b text_center cursor_p" v-else
                       @click="toggleService(item.type)"></div>
                </div>
              </div> -->
              
              <!-- 2 补充服务条件 -->
                <div class="serviceTitle pr">
                  <span class="f_18 color_40 font_w_b">补充服务条件</span>
                  <div class="pa color_fff f_18 text_center">2</div>
                </div>
             

              <el-form :model="formData" :rules="rules" ref="newsData" class="clearfix">
                <!-- 最高学历 -->
                <div class="formItem" v-if="formData.plan !== 'full'">
                  <div class="formTitle color_40 f_16">最高学历</div>
                  <el-select v-model="formData.degree" placeholder="请选择" class="optionBlock">
                    <el-option
                        v-for="item in newsData.degree"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <!-- 求职目标行业 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">求职目标行业</div>
                  <el-select v-model="formData.industry" placeholder="请选择" class="optionBlock" @change="optionChange()">
                    <el-option
                        v-for="item in newsData.industry"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <template v-if="formData.plan !== 'full'">
                  <!-- 是否有海外经历 -->
                  <div class="formItem profession">
                    <div class="formTitle color_40 f_16">
                      是否有海外经历
                      <div class="iconfont iconwenhao cursor_p pr">
                        <div class="tipsText pa color_fff f_12">如具有留学、交换、暑校等海外经历，请勾选“是”，我们会为你匹配熟悉留学生求职事宜的导师为你提供服务，最大化利用这段经历</div>
                      </div>
                    </div>
                    <el-select v-model="formData.mentor_type" placeholder="请选择" class="optionBlock">
                      <el-option
                          v-for="item in newsData.mentor_type"
                          :key="item.name"
                          :label="item.value"
                          :value="item.name">
                      </el-option>
                    </el-select>
                  </div>
                  <!-- 跨专业求职 -->
                  <div class="formItem">
                    <div class="formTitle color_40 f_16">{{formData.plan === 'intern' ? '是否零经验求职' : '非本专业求职'}}</div>
                    <el-select v-model="formData.change_profession" placeholder="请选择" class="optionBlock">
                      <el-option
                          v-for="item in newsData.change_profession"
                          :key="item.name"
                          :label="item.value"
                          :value="item.name">
                      </el-option>
                    </el-select>
                  </div>
                </template>
                <template v-else>
                  <!-- 工作经验 -->
                  <div class="formItem">
                    <div class="formTitle color_40 f_16">工作经验</div>
                    <el-select v-model="formData.work_year" placeholder="请选择" class="optionBlock">
                      <el-option
                          v-for="item in newsData.work_year"
                          :key="item.name"
                          :label="item.value"
                          :value="item.name">
                      </el-option>
                    </el-select>
                  </div>
                  <!-- 是否转行求职 -->
                  <div class="formItem profession">
                    <div class="formTitle color_40 f_16">是否转行求职</div>
                    <el-select v-model="formData.change_profession" placeholder="请选择" class="optionBlock">
                      <el-option
                          v-for="item in newsData.change_profession"
                          :key="item.name"
                          :label="item.value"
                          :value="item.name">
                      </el-option>
                    </el-select>
                  </div>
                  <!-- 职业经历瑕疵修复 -->
                  <div class="formItem">
                    <div class="formTitle color_40 f_16">
                      职业经历瑕疵修复
                      <div class="iconfont iconwenhao cursor_p pr">
                        <div class="tipsText pa color_fff f_12">
                          <p>如果在你的职业生涯中，出现过「待业半年以上」「一年内更换工作超过3次」「未过试用期被辞退」「被裁员」等影响后续求职的经历，请选择「需要」；</p>
                          <p>我们会为您分配人力资源经验最丰富的导师，帮您最大可能的把这些不利因素消除</p>
                        </div>
                      </div>
                    </div>
                    <el-select v-model="formData.defect_repair" placeholder="请选择" class="optionBlock">
                      <el-option
                          v-for="item in newsData.defect_repair"
                          :key="item.name"
                          :label="item.value"
                          :value="item.name">
                      </el-option>
                    </el-select>
                  </div>
                </template>

                <!-- 简历语言选择 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">简历语言选择</div>
                  <el-select v-model="formData.cv_lang" placeholder="请选择" class="optionBlock" :disabled="!formData.cv_optimization">
                    <el-option
                        v-for="item in newsData.cv_lang"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <!-- 是否需要加急 -->
                <div class="formItem urgency">
                  <div class="formTitle color_40 f_16">是否需要加急</div>
                  <el-select v-model="formData.urgency" placeholder="请选择" class="optionBlock">
                    <el-option
                        v-for="item in newsData.urgency"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </el-form>


            </div>

            <!-- 必要条件 -->
            <!-- <div class="service clearfix" style=" margin-top:30px">
              <div class="serviceTitle pr" style="">
                <span class="f_18 color_40 font_w_b">补充必要信息</span>
                <div class="pa color_fff f_18 text_center">3</div>
              </div>
              <div class="form">
                中文简历
                  <div class="formItem" v-show='cv_lang_name==="中英双语简历" ? (newsData.en_cv_options.length && newsData.cn_cv_options.length) : newsData.cn_cv_options.length' style="margin-right:32px">
                    <div class="formTitle color_40 f_16"><span class='color_red ' style="display:inline-block;margin-right:5px">*</span>中文简历</div>
                    <el-select v-model="formData.cv_id" placeholder="请选择" class="optionBlock" @change="optionChange()">
                      <el-option
                      v-for="item in newsData.cn_cv_options"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                     </el-option>
                    </el-select>
                  </div>
                  英文简历
                  <div class="formItem" v-show='cv_lang_name==="中英双语简历" && (newsData.en_cv_options.length && newsData.cn_cv_options.length)'  >
                   <div class="formTitle color_40 f_16"><span class='color_red ' style="display:inline-block;margin-right:5px">*</span>英文简历</div>
                    <el-select v-model="formData.cv2_id" placeholder="请选择" class="optionBlock" @change="optionChange()">
                      <el-option
                      v-for="item in newsData.en_cv_options"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                       </el-option>
                    </el-select>
                  </div>
                  电话号码
                  <div class="formItem" >
                   <div class="formTitle color_40 f_16" ><span class='color_red ' style="display:inline-block;margin-right:5px">*</span>常用手机号</div>
                    <div class="pleaseChoose optionBlock" style="width: 310px;
      height: 38px;
      border-radius:4px;
      border:1px solid rgba(216,216,216,1);color:rgba(188,188,188,1);text-align:left; padding-left:16px;line-height:38px;cursor: pointer;" @click="showBindTips=true">{{formData.phone || '请输入'}}</div>
                  </div>
                </div>
            </div> -->

          </div>
        <div class="service-other">
          <div class="process">
            <div class="right-content-title">服务流程</div>

            <!-- <div class="process-item" v-for="(item, index) in processMap[formData.plan]" :key="`process-item&${index}`">
              <h6>{{ item.title }}</h6>
              <p>{{ item.subtitle }}</p>
            </div> -->
            <div class="process-item2">
            <img :src="newimage" alt="" width="135%">
            </div>
          </div>
          <div class="problem">
            <div class="problemTitle f_16 color_60 pr">如果你有以下疑问</div>
            <div class="list" v-for="(item,index) in newsData.faq_items" :key='index'>
              <div class='title f_14 color_40 pr ellipsis2' @click="toggleDescription(index)">
                {{`${index + 1}.${item.title}`}}
                <div :class="['icon pa', item.showDescription ? 'current' : '']"></div>
              </div>
              <div class="text color_9c f_14" v-html="item.descrpition" v-show="item.showDescription"></div>
            </div>
          </div>
      </div>
        


          <!-- <div class="couponBox bg_fff">
            <div class="listTitle f_18 color_40 pr">
              <span class="font_w_b">使用优惠券</span>
              <a href="/account/users/current" target="_blank" class="fr more f_14 color_90" v-show="coupons.length">查看全部优惠券
                <span class="iconfont iconchevron-right"></span></a>
            </div>
            <div class="couponInput clearfix flex">
              <input type="text" placeholder="请输入优惠兑换码" class="flex1 f_12" v-model="partner">
              <div class='bg_red color_fff f_14 couponSubmit text_center' @click="couponCreate()">兑换</div>
            </div>
            <div class="couponList clearfix">
              <div :class="['list fl flex-c', coupon.id===item.id ? 'current' :'']" v-for="(item,index) in coupons"
                   :key="item.id" @click="toggleCoupon(item,index)">
                <div class='money f_18 font_w_b text_center pr'><span class="pr">¥</span>{{item.count}}</div>
                <div class="des flex1 text_center pr">
                  <div class="name f_14 ellipsis color_40">{{item.name}}</div>
                  <div class="time f_12 ellipsis color_90" v-if="item.expiry">有效期：{{item.expiry}}</div>
                </div>
              </div>
            </div>

          </div> -->

        </div>
        <!-- 右侧问题 -->
        <div class="w340 fr right-content">

          <!-- 服务内容 -->
          <!-- <div class="description">
            <div class="right-content-title">{{ planType[formData.plan].title }}-服务内容</div>

            <div class="description-item" v-for="(item, index) in descriptionMap[formData.plan]" :key="`description-item&${index}`">
              <img class="description-item-icon" :src="item.imgSrc" alt="">
              <div class="description-item-info">
                <h6>{{ item.title }}</h6>
                <p>{{ item.subtitle }}</p>
              </div>
            </div>

          </div> -->

          <!-- 服务流程 -->
          <!-- <div class="process">
            <div class="right-content-title">服务流程</div>

            <div class="process-item" v-for="(item, index) in processMap[formData.plan]" :key="`process-item&${index}`">
              <h6>{{ item.title }}</h6>
              <p>{{ item.subtitle }}</p>
            </div>

          </div> -->
          
          <!-- <div class="problem">
            <div class="problemTitle f_16 color_60 pr">如果你有以下疑问</div>
            <div class="list" v-for="(item,index) in newsData.faq_items" :key='index'>
              <div class='title f_14 color_40 pr ellipsis2' @click="toggleDescription(index)">
                {{`${index + 1}.${item.title}`}}
                <div :class="['icon pa', item.showDescription ? 'current' : '']"></div>
              </div>
              <div class="text color_9c f_14" v-html="item.descrpition" v-show="item.showDescription"></div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- 底部菜单 -->
      <div class='footerBar bg_fff'>
        <div class="cont">
          
          <!-- 选择内容 -->
          <div class="des footerBar-left">
            <div class="name color_40 f_14">产品名称：<span class="color_red">【{{planType[formData.plan].title}}】</span>
            <span class="color_red text" v-if="formData.cv_optimization">简历优化</span>
            <span class="color_red text" v-if="formData.interview_guidance">面试辅导</span>
            <span class="color_red text" v-if="formData.interview_simulation">面试模拟</span>
            <span class="color_red text" v-if="formData.career_plan">职业规划</span>
            </div>
            <div class="service flex">
              <div class='sname color_40 f_14'>服务条件：</div>
              <div class="color_60 f_12 flex1">
                <p class="newChangeCss">
                  <span v-if="degree_name">【{{degree_name}}】</span>
                  <span v-if="mentor_type_name && mentor_type_name === '是'">【海外经历】</span>
                  <span v-if="cv_lang_name">【{{cv_lang_name}}】</span>
                  <span v-if="industry_name">【{{industry_name}}】</span>
                  <span v-if="work_year_name">【{{work_year_name}}】</span>
                  <span v-if="formData.urgency === 'normal'">【正常：3 天反馈】</span>
                  <span v-else-if="formData.urgency === '24hours'">【加急：1 天反馈】</span>
                  <span v-if="formData.change_profession && formData.plan==='full'">【转行】</span>
                  <span v-if="formData.change_profession && formData.plan!=='full'">{{formData.plan === 'intern' ? '【零经验】' : '【非本专业求职】'}}</span>
                  <span v-if="formData.defect_repair">【职业经历瑕疵修复】</span>
                </p>
              </div>
            </div>
          </div>

          <div class="footerBar-right">
            <!-- 优惠券 -->
            <div class="orderCont">
              <div class="money f_16 color_40" style="margin-top:16px;" v-if="money>-1 && needGetMoney" >总计价格：<span class='f_28 color_red pr'>¥ <span>{{money}}</span><del v-if="del_price" class="del-price">{{originPrice}}</del></span></div>
              <div class="money f_16 color_40" style="margin-top:16px;" v-else >总计价格：<span class='f_28 color_red pr'>···</span></div>
              <div class="couponMoney f_14 color_red" v-if="coupons.length" @click="showCouponsAlert = true">优惠券：- ¥ {{ couponsPrice }}<i class="iconfont iconchevron-right"></i>
              </div>
              <div @click="showCouponsAlert = true" class="use_coupons" v-else>使用优惠券
                <i class="iconfont iconchevron-right"></i>
              </div>
            <div class="terms f_12" style="color:gray"><span class="cursor_p" @click="toggleServiceBg('snameState')">下单即默认同意《服务协议》</span></div>
            </div>
            <!-- 购买按钮 -->
            <div class="payButton color_fff bg_red text_center f_18" @click="formSubmit('newsData')">立即购买</div>
          </div>

        </div>
      </div>
      <!-- 背景 -->
      <div class="serviceBg" v-if="addIndustryState || snameState"></div>
      <!-- 添加自定义目标行业 -->
      <div class="addIndustry bg_fff" v-if="addIndustryState">
        <div class="title font_w_b f_18 color_40">求职目标行业</div>
        <el-input v-model="formData.custom_industry" placeholder="请填写" class="optionBlock" maxlength="15"/>
        <div class="templateButtons clearfix f_14 text_center">
          <div class="confirm fr cursor_p color_fff" :class="[!formData.custom_industry?'disabled':'']"
               @click="formData.custom_industry?toggleServiceBg('addIndustryState') : ''">确定
          </div>
          <div class="cancel fr cursor_p color_60"
               @click="formData.custom_industry=''; formData.industry=''; toggleServiceBg('addIndustryState')">取消
          </div>
        </div>
      </div>
      <!-- 添加目标行业 -->
      <div class="snameContent bg_fff" v-if="snameState">
        <div class="title f_20 color_40 text_center pr font_w_b">《导师服务协议》
          <div class="iconfont iconx pa color_90 font_w_b cursor_p" @click="toggleServiceBg('snameState')"></div>
        </div>
        <div class="textContent f_14 color_60">
          <div v-html="snameContent"></div>
        </div>

      </div>
    </div>
    <pay-mentor
      v-if="isShowPay"
      :orderId="orderId"
      :currentServiceData="orderService[formData.plan+'Service']"
      :orderReq="orderReq"
      :money="money"
      :detail="{degree_name, mentor_type_name: (mentor_type_name === '是' && '海外经历'), cv_lang_name, industry_name, work_year_name, urgency: (formData.urgency === 'normal' ? '正常：3 天反馈' : '加急：1 天反馈'), change_profession: formData.change_profession, defect_repair: formData.defect_repair && `职业经历瑕疵修复`}" 
      :orderPriceData="orderPriceData"
      @close="isShowPay=false"
    />
    <bindPhone v-if="showBindTips" @cancelBindForm='cancelBindForm' @success='success'/>
    <coupons-alert  v-if="showCouponsAlert" @close='showCouponsAlert=false' @getCouponId='getCouponId' :plan="formData.plan" :couponId='coupon.id'/>
  </div>
</template>
<script>
  import api from '@/api';
  import {mapGetters, mapActions} from 'vuex'
  import {routerTo, get_tUser, auth} from '@/assets/js/util';
  import {serviceOptions, internService, campusService, fullService, snameContent,} from '@/assets/js/service';
  import PcNavbar from '@/components/base/navbar';
  import payMentor from "./payMentor";
  import bindPhone from './phone';
  import couponsAlert from './coupons';
  export default {
    name: 'orderCreat',
    layout: 'notTop',
    data() {
      var validateIndustry = (rule, value, callback) => {
        if (!this.industry.value) {
          callback(new Error('请选择目标行业领域'));
        } else {
          callback();
        }
      };
      var validateWorkYear = (rule, value, callback) => {
        if (this.plan == 'full' && !this.work_year.value) {
          callback(new Error('请选择工作经验'));
        } else {
          callback();
        }
      }
      return {
        flag: false, // 用于点击立即购买判断是否在这绑定手机号 确定成功之后才传过来true
        showCouponsAlert:false,//优惠券弹窗
        showBindTips:false, //填写手机号
        newimage:'',//动态更换实习导师辅导页面购买图片
        _c_t: '',
        price: '', //基础价格
        planType: { //获取标题们
          intern: {
            title: '实习版',
            banner: ''
          },
          campus: {
            title: '校招版',
            banner: ''
          },
          full: {
            title: '在职版',
            banner: ''
          },
        },
        orderReq: {},
        orderPriceData: {},
        position:'',
        serviceOptions,
        snameContent,
        orderService: {
          internService,
          campusService,
          fullService
        },
        formData: { //保存表单
          plan: '',
          cv_lang: "cn", //语言类型
          industry: 'it', //目标行业
          work_year: '', //工作经验
          change_profession: false, //是否转行
          urgency: '', //加急系数
          coupon_id: '', //优惠券id
          cv_optimization: true, //简历优化
          interview_guidance: false, //面试辅导
          interview_simulation: false, //面试模拟训练
          career_plan: false, //职业规划
          // professional_test: false, //专业测试
          defect_repair: false, //职业经历瑕疵修复
          custom_industry: '', //自定义求职目标行业
          degree: '', //最高学历
          mentor_type: '', //导师类型
          cv_id: '', //选择中文简历
          cv2_id: '', //选择英文简历
          cn_cv_options:'', //选择中文简历
          en_cv_options: '', //选择英文简历
          // phone:'',
        },
        newsData: { //页面下拉菜单数据
          change_profession: [{ //是否转行（实习版、校招版显示文案为“是否跨专业求职”）
            value: '是',
            name: true,
          }, {
            value: '否',
            name: false,
          }],
          defect_repair: [{ //职业经历瑕疵修复
            value: '需要',
            name: true,
          }, {
            value: '不需要',
            name: false,
          }],
          ch_resume:'', //选择中文简历
          en_resume: '', //选择英文简历
        },
        coupons: [], //优惠券列表
        coupon: {}, //优惠券 id
        partner: '', //优惠券-输入框
        loading: false,
        newsShowIndex: 0,
        rules: {
          industry: [
            {validator: validateIndustry, trigger: 'change'}
          ],

        },
        money:-1, //订单money
        getMoneyName:null, //是否正在获取钱的状态
        // moneyOptions: {
        //   interview_guidance: { //面试辅导
        //     intern: {
        //       finance: 300,
        //       non_finance: 200
        //     },
        //     campus: {
        //       finance: 300,
        //       non_finance: 250
        //     },
        //     full: {
        //       finance: 400,
        //       non_finance: 300
        //     },
        //   },
        //   interview_simulation: { //面试模拟训练
        //     intern: {
        //       finance: 0,
        //       non_finance: 0
        //     },
        //     campus: {
        //       finance: 350,
        //       non_finance: 300
        //     },
        //     full: {
        //       finance: 0,
        //       non_finance: 0
        //     },
        //   },
        //   career_plan: { //职业规划
        //     intern: {
        //       finance: 0,
        //       non_finance: 0
        //     },
        //     campus: {
        //       finance: 300,
        //       non_finance: 250
        //     },
        //     full: {
        //       finance: 400,
        //       non_finance: 350
        //     },
        //   },
        //   professional_test: { //专业测试
        //     intern: {
        //       finance: 30,
        //       non_finance: 30
        //     },
        //     campus: {
        //       finance: 50,
        //       non_finance: 50
        //     },
        //     full: {
        //       finance: 50,
        //       non_finance: 50
        //     },
        //   },
        // },
        couponsPrice: '0.00', // 优惠券优惠的价格
        addIndustryState: false, //添加自定义目标行业
        snameState: false, //添加目标行业
        isShowPay: false, //显示订单支付弹窗
        orderId: "", //订单token,
        totalPrice: 0, // 未打折优惠时的订单价格
        // 映射图 服务内容
        descriptionMap: { 
          intern: [ // 实习版
            {
              title: '简历优化',
              subtitle: '调整简历格式，精修简历内容，匹配目标JD突出经历亮点，提升简历竞争力',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon1.png'
            },
            {
              title: '面试辅导',
              subtitle: '30～60分钟语音沟通，热门面试题解析，针对目标岗位面试辅导',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon2.png'
            }
          ],
          campus: [ // 校招版
            {
              title: '简历优化',
              subtitle: '调整简历格式，精修简历内容，匹配目标JD突出经历亮点，提升简历竞争力',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon1.png'
            },
            {
              title: '面试辅导',
              subtitle: '30～60分钟语音沟通，热门面试题解析，针对目标岗位面试辅导',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon2.png'
            },
            {
              title: '面试模拟',
              subtitle: '30～60分钟语音沟通，还原真实面试场景 + 面试复盘',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon3.png'
            },
            {
              title: '职业规划',
              subtitle: '30～60分钟语音沟通，基础信息了解 + 职业生涯问题评估 + 经历优劣势分析 + 职业性格分析 + 行业、岗位分析',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon4.png'
            }
          ],
          full: [ // 在职版
            {
              title: '简历优化',
              subtitle: '调整简历格式，精修简历内容，匹配目标JD突出经历亮点，提升简历竞争力',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon1.png'
            },
            {
              title: '面试辅导',
              subtitle: '30～60分钟语音沟通，热门面试题解析，针对目标岗位面试辅导',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon2.png'
            },
            {
              title: '面试模拟',
              subtitle: '30～60分钟语音沟通，还原真实面试场景 + 面试复盘',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon3.png'
            },
            {
              title: '职业规划',
              subtitle: '30～60分钟语音沟通，基础信息了解 + 职业生涯问题评估 + 经历优劣势分析 + 职业性格分析 + 行业、岗位分析',
              imgSrc: 'https://files.wondercv.com/PC/mentor/icon4.png'
            }
          ]
        },
        // 映射图 服务流程
        processMap: { 
          intern: [ // 实习版
            {
              title: '信息填写',
              subtitle: '选择服务内容、个人情况和要修改的简历'
            },
            {
              title: '导师匹配',
              subtitle: '通过行业 & 简历专业分析，2小时内匹配最适合导师'
            },
            {
              title: '详细沟通',
              subtitle: '沟通修改需求，制定优化方案'
            },
            {
              title: '简历修改',
              subtitle: '3～5天内交付初稿'
            },
            {
              title: '售后保障',
              subtitle: '购买后10天售后期，帮你解决任何问题'
            }
          ],
          campus: [ // 校招版
            {
              title: '信息填写',
              subtitle: '选择服务内容、个人情况和要修改的简历'
            },
            {
              title: '导师匹配',
              subtitle: '通过行业 & 简历专业分析，2小时内匹配最适合导师'
            },
            {
              title: '详细沟通',
              subtitle: '沟通修改需求，制定优化方案'
            },
            {
              title: '简历修改',
              subtitle: '3～5天内交付初稿，7天内多次调整'
            },
            {
              title: '售后保障',
              subtitle: '购买后10天售后期，帮你解决任何问题'
            }
          ],
          full: [ // 在职版
            {
              title: '信息填写',
              subtitle: '选择服务内容、个人情况和要修改的简历'
            },
            {
              title: '导师匹配',
              subtitle: '通过行业 & 简历专业分析，2小时内匹配最适合导师'
            },
            {
              title: '详细沟通',
              subtitle: '沟通修改需求，制定优化方案'
            },
            {
              title: '简历修改',
              subtitle: '3～5天内交付初稿，7天内多次调整'
            },
            {
              title: '售后保障',
              subtitle: '购买后10天售后期，帮你解决任何问题'
            }
          ]
        },
        originPrice: 0, //未打折之前的价格
        serviceBanner: '' // 服务banner
      }
    },
    created() {
     //console.log(this.cv_lang_name)
      this._c_t = get_tUser().c_t || '';
      //修改高亮位置
      this.$store.dispatch('app/setNavbarAction', '简历修改');

      this.formData.plan = this.$route.query.plan || ''; //intern实习 campus校招 full在职
      //检查是否登录
      if (!this._c_t) {
        //未登录
        routerTo('/signin?type=login')
        return false;
      }
      // 获取数据
      this.getData();
      // 获取banner
      this.getBanner()
      this.checkimage()
    },
    methods: {
      success(flag,phone) {
        //console.log(flag)
        this.flag = true
        this.formData.phone = phone;
      },
      serviceBannerClick() {
        if (this.serviceBanner.link) {
          window.open(this.serviceBanner.link, '_blank')
        }
      },
      async getBanner() {
        let resRouter=this.$route.query.plan;
        console.log(resRouter,1111)
        if(resRouter=='intern'){
          //实习版
          this.position=70;
        }else if(resRouter=='campus'){
          //校招版
           this.position=87;
        }else if(resRouter=='full'){
          //在职版
           this.position=88;
        }
        let res = await api.jobs.getBanner({position: this.position})
        if(res.code == 1000) {
          this.serviceBanner = res.data[0]
        }
      },
      async getCouponId (id,coupons) {
        if(coupons){
          this.coupons.unshift(coupons)
        }
        //  console.log(id)
        this.coupons.forEach((element,index) => {
          if(element.id == id) {
            // this.totalPrice = 0
            this.formData.coupon_id = id
            this.coupon.id = id
            this.coupon.index = index
          }
        });
      },
      //获取页面信息
      getData() {
        let { plan } = this.formData;
        api.mentorOrders.mentorOrdersNew({plan: plan}).then(res => {
          if (res.code === 1000) {
            // res.data.faq_items[0].showDescription = true
            this.newsData = {
              ...this.newsData,
              ...res.data
            };
            // 已有手机号跳过手机号验证
            // if (this.newsData.phone) {
            //   this.success('', this.newsData.phone)
            // }
            let {coupons, urgency, cv_lang, degree, faq_items, industry, mentor_type, price, work_year, cn_cv_options, en_cv_options, phone} = res.data;
             this.coupons = coupons;
            if (coupons.length > 0) {

              this.formData.coupon_id = coupons[0].id;
              this.coupon = {
                id: coupons[0].id,
                index: 0
              }
            }
            this.price = price / 100;
             //中文简历
            this.formData.cn_cv_options = cn_cv_options.length ? cn_cv_options[0].name : ''
            //英文简历
            this.formData.en_cv_options = en_cv_options.length ? en_cv_options[0].name : ''

            // 简历语言
            // this.formData.cv_lang = cv_lang[0].name;
            //默认中文简历第一个
            // this.formData.cv_id = cn_cv_options.length ? cn_cv_options[0].value : '';
            // 是否加急
            this.formData.urgency = urgency[0].name;

            if (plan === 'full') {
              // 工作经验
              // this.formData.work_year = work_year[0].name;
            } else {
              // 最高学历
              this.formData.degree = degree[0].name;
              // 是否有海外经历
              this.formData.mentor_type = mentor_type[0].name;
            }
            // this.formData.phone = phone
          }
        })
        .catch(err => {
        })
      },
      checkimage(){
        console.log(this.planType[this.formData.plan].title)
        if(this.planType[this.formData.plan].title == '实习版'){
          this.newimage='https://files.wondercv.com/PC/service/service_intern_liucheng.png';
        }else{
          this.newimage='https://files.wondercv.com/PC/service/service_liucheng.png';
        }
      },
      // 切换服务类型
      toggleService(type) {
        if (!type) {
          return
        }
        this.formData[type] = !this.formData[type];
        //如果没有选择简历优化，清空简历语言
        if(!this.formData.cv_optimization){
          this.formData.cv_lang = null
        }
      },
      //优惠券
      /*async couponCreate() {
        if (this.loading) {
          return false;
        }
        this.loading = true;
        await api.account.couponsCreate({partner: this.partner})
          .then(res => {
            this.loading = false;
            if (res.status === 1) {
              this.partner = '';
              this.coupons = res.data.coupons;
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {
            this.loading = false;
          })
      
      },*/
      //立即购买
      formSubmit(formName) {
        if(!this.needGetMoney){
          this.$message.error('请选择服务内容')
          return
        }
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            return false;
          }
          if (!this.formData.industry) {
            this.$message.error('请选择目标行业')
            return false;
          }
          if (this.formData.plan == 'full') {
            if (!this.formData.work_year) {
              this.$message.error('请选择工作经验')
              return false;
            }
          }
          if (this.formData.cv_optimization) {
            if(!this.formData.cv_lang){
              this.$message.error('请选择简历语言')
              return false;
            }
          }else{
            this.formData.cv_lang = null
          }
          // if (!this.flag ) {
          //   this.$message.error('请输入手机号')
          //   return false;
          // }
          // 选择简历放到提问题页面
          // if(this.formData.cv_lang!== "cn_en" ) {
          //   this.formData.cv2_id = ''
          // }else if(this.formData.cv_lang === "cn_en" && ( !this.newsData.en_cv_options.length || !this.newsData.cn_cv_options.length ) ){
          //   //如果是中英双语简历，但是没有中文/英文简历可选，清空中文简历默认项
          //   this.formData.cv_id = ''
          // }
          let param = JSON.parse(JSON.stringify(this.formData))
          // 默认没有海外经历
          if(!param.mentor_type) {
            param.mentor_type = 'cn'
          }
          if(!param.degree){
            param.degree = 'undergraduate'
          } 
          let p = this.getNewOrderParam(param) 
          param.price_params = p
          this.orderReq = JSON.parse(JSON.stringify(param));    
          api.mentorOrders.mentorOrdersCreate(param).then(res => {
            let {data: {order_token}, code} = res
            //console.log(res,this.formData)
            if (res.code === 1000) {
              // this.coupons.splice(this.coupon.index,1)
              //console.log(this.coupon.index,this.coupons)
              this.orderId = order_token
              // window.location.href=`${window.location.origin}/orders/${res.data.order_token}`
              this.isShowPay = true
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {
            //console.log(err)
            this.$message.error('cateac'+err)
          })

        });
      },
      //下拉框更新数据
      optionChange() {
        let {industry} = this.formData;
        if (industry === 'other') {
          this.formData.custom_industry = '';
          this.toggleServiceBg('addIndustryState')
        }
      },
      //切换优惠券
      /* toggleCoupon(item, index) {
        if (this.coupon.id === item.id) {
          //替换
          this.coupon = {};
          this.formData.coupon_id = '';
        } else {
          this.formData.coupon_id = item.id;
          this.coupon = {
            id: item.id,
            index
          }
        }
      }, */
      //是否显示描述
      toggleDescription(index) {
        let item = JSON.parse(JSON.stringify(this.newsData.faq_items[index]));
        item.showDescription = !item.showDescription;
        this.$set(this.newsData.faq_items, index, item)
      },
      //切换当前状态
      toggleServiceBg(type) {
        if (this[type]) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        } else {
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
        this[type] = !this[type]
      },
      //电话弹窗
      cancelBindForm(phone){
        this.showBindTips = false;
      },
      // 获取新的价格参数
      getNewOrderParam(param){
        let newparam = {
          basic_service: [],
          special_service: [],
          work_year: 4,
          industry: 9,
          plan: param.plan,
          coupon_id: param.coupon_id,
          channel: 0,
        };
        // 整理基础服务
        ['interview_guidance','interview_simulation','career_plan'].forEach(key => {
          if(!!param[key]){
            newparam.basic_service.push(key)
          }   
        })
        if(param.cv_optimization) newparam.basic_service.push('cv_optimize')

        // 行业
        let industryServe = {
          'it': 9,
          'finance': 2,
          'advert_media': 5,
          'kuaixiao': 4,
          'tech': 6,
          'buildings': 7,
          'other': 8
        }
        newparam.industry = industryServe[param.industry]
        
        // 特殊服务
        let specialServe = {
          urgency: {rightval: '24hours', value: 'urgency'},
          defect_repair: {rightval: true, value: 'defect_repair'},
          change_profession: {rightval: true, value: 'change_profession'},
          mentor_type: {rightval: 'en', value: 'aboard'},
          cv_lang: {rightval: 'cn_en', value: 'cn_en'},
          degree: {rightval: 'master', value: 'master_degree'}, 
        }
        Object.keys(specialServe).forEach(key => {
          if(param[key] == specialServe[key].rightval) {
            newparam.special_service.push(specialServe[key].value)
          }
        })

        // 工作年限
        newparam.work_year = param.work_year == 'years8_100' ? 12 : parseInt(param.work_year.slice(-1)) + 3 

        return newparam
      },
      //获取订单价格
      getOrdersPrice(){
        if(!this.needGetMoney){
          return
        }
        clearTimeout(this.getMoneyName);
        this.money = -1;
        this.orderPriceData = {};
        this.getMoneyName = setTimeout(() => {
          console.log('getOrdersPrice=>>',this.formData)
          let param = JSON.parse(JSON.stringify(this.formData))
          // 默认没有海外经历
          if(!param.mentor_type) {
            param.mentor_type = 'cn'
          }
          if(!param.degree){
            param.degree = 'undergraduate'
          }
          let p = this.getNewOrderParam(param)     
          api.mentorOrders.getOrdersPrice(p).then(res=>{
            if(res.code === 1000){
              this.money =  res.data.total_price / 100
              this.originPrice = res.data.origin_total_price / 100
              this.couponsPrice = res.data.coupon_price / 100
              this.orderPriceData = res.data
            }
          })
        }, 500);
        
      },
    },
    components: {
      PcNavbar,
      payMentor,
      bindPhone,
      couponsAlert
    },
    computed: {
      //是否需要获取钱
      needGetMoney(){
        let { cv_optimization, interview_guidance, interview_simulation, career_plan  } = this.formData
        return cv_optimization || interview_guidance || interview_simulation || career_plan
      },
      //计算钱，仅作展示
      /*money() {
        let {work_year, urgency, coupon_id, industry, degree, plan, change_profession, mentor_type, cv_lang, defect_repair, interview_guidance, interview_simulation, career_plan, professional_test,} = this.formData;

        // 薪资相关计算转：http://wiki.wondercv.cn/pages/viewpage.action?pageId=10059978
        let price = 0;
        if (this.price) {
          price = Number(this.price);
          // 硕士及以上加钱
          if (degree === 'master') {
            // 实习版
            if (plan === 'intern') {
              price += 30;
            } else if (plan === 'campus') {
              //校招
              price += 50;
            }
          }
          // 商科
          if (industry === 'finance') {
            // 基价+70/50
            price += 50;
          }
          //跨专业
          if (change_profession) {
            // 全职版
            price += plan === 'full' ? 100 : 50;
          }

          //中英文
          if (cv_lang === 'cn_en') {
            price = price*2.5;
          }

          //海外导师
          if (mentor_type === 'en') {
            price += 200;
          }

          //加急
          if (urgency === '24hours') {
            //全职
            price += plan === 'full' ? 150 : 100;
          }
          // 职业经历瑕疵修复
          if (defect_repair) {
            // 商科
            price += industry === 'finance' ? 150 : 100;
          }

          //面试辅导
          if (interview_guidance) {
            //console.log(industry, this.moneyOptions.interview_guidance[plan], this.moneyOptions.interview_guidance[plan][industry !== 'finance' ? 'finance' : 'non_finance'])
            price += this.moneyOptions.interview_guidance[plan][industry === 'finance' ? 'finance' : 'non_finance']
          }
          //面试模拟训练
          if (interview_simulation) {
            price += this.moneyOptions.interview_simulation[plan][industry === 'finance' ? 'finance' : 'non_finance']
          }
          //职业规划
          if (career_plan) {
            price += this.moneyOptions.career_plan[plan][industry === 'finance' ? 'finance' : 'non_finance']
          }
          //专业测试
          if (professional_test) {
            price += this.moneyOptions.professional_test[plan][industry === 'finance' ? 'finance' : 'non_finance']
          }
          // 商科
          if (industry === 'finance') {
            //跨专业 && 全职版
            if (change_profession && plan === 'full') {
              price += 50;
            }
            //加急 && 全职
            if (urgency === '24hours') {
              price += 50;
            }
            //年限价格
            if (work_year) {
              let workYearIndex = this.newsData.work_year.findIndex(item => item.name === work_year);
              if (workYearIndex <= 4) {
                if (workYearIndex > 0) {
                  price += 499 - 349;
                }
              } else if (workYearIndex <= 7) {
                price += 699 - 349;
              } else {
                price += 849 - 349;
              }
            }

          } else {
            //年限价格
            if (work_year) {
              let workYearIndex = this.newsData.work_year.findIndex(item => item.name === work_year);
              //console.log(workYearIndex)
              if (workYearIndex <= 4) {
                if (workYearIndex > 0) {
                  price += 399 - 299;
                }
              } else if (workYearIndex <= 7) {
                price += 599 - 299;
              } else {
                price += 699 - 299;
              }
            }
          }

          // 未优惠打折之前所应该付款的总款项
          this.totalPrice = price

          //计算优惠券
          if (coupon_id) {
            let couponItem = this.coupons.filter(item => item.id === coupon_id)[0];
            if (couponItem) {
              if (couponItem.discount) {
                // 折扣优惠券打折计算
                price = price - price * (1 - couponItem.discount)
              }else {
                price = price - (couponItem.cent/100 || couponItem.count)
              }
            }
          }
          price = price.toFixed(2)
          return price < 0 ? 0 : price
        }

      }, */
      ch_resume_id() {
       if(this.newsData.cn_cv_options.length > 0) {
        let {cn_cv_options} = this.formData;
        let options = this.newsData.cn_cv_options;
        // console.log(options,cn_cv_options)
        let item = options.filter(item => item.name === cn_cv_options) || []
        //console.log(item)
        return item.length ? item[0].value : ''
       }
       return ''
      },
      en_resume_id() {
        if(this.newsData.cn_cv_options.length > 0) {
        let {en_cv_options} = this.formData;
        let options = this.newsData.en_cv_options;
        let item = options.filter(item => item.name === en_cv_options) || []
        return item.length ? item[0].value : ''
      }
        return ''
      },
      degree_name() {
        let {degree} = this.formData;
        let options = this.newsData.degree;
        let item = options.filter(item => item.name === degree) || []
        return item.length ? item[0].value : ''
      },
      mentor_type_name() {
        let {mentor_type} = this.formData;
        let options = this.newsData.mentor_type;
        let item = options.filter(item => item.name === mentor_type) || []
        return item.length ? item[0].value : ''
      },
      cv_lang_name() {
        let {cv_lang} = this.formData;
        let options = this.newsData.cv_lang;
        let item = options ? options.filter(item => item.name === cv_lang) : []
        return item.length ? item[0].value :''

      },
      industry_name() {
        let {industry} = this.formData;
        let options = this.newsData.industry;
        let item = options.filter(item => item.name === industry) || []
        return item.length ? item[0].value : ''
      },
      work_year_name() {
        let {work_year} = this.formData;
        let options = this.newsData.work_year;
        let item = options.filter(item => item.name === work_year) || []
        return item.length ? item[0].value : ''
      },
      
      //是否显示划线价格
      del_price(){
        let {cv_optimization,interview_guidance,interview_simulation,career_plan}=this.formData
        const newArr=[cv_optimization,interview_guidance,interview_simulation,career_plan];
        const delPrice =[]
        newArr.forEach((item)=>{
          if(item) delPrice.push(item);
        })
        if(delPrice.length>=2) return true;
        return false
      },


    },
    watch: {
      'formData': {
        handler:function() {
          this.getOrdersPrice();
        },
        deep: true    //深度监听
      }
    }
  }
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  @import './index.scss';
</style>
<style lang="scss">
  .orderCreate {
    .el-form-item {
      margin-bottom: 0;
    }

    .content{
      .w340{
        border-radius: 2px;
        overflow: hidden;
      }
    }

    .el-form-item__error {
      margin-top: -18px;
    }
    .margin {
      margin-right: 30px;
    }
    .newChangeCss {
      margin-top: 5px;
      line-height: 22px;

      span {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: #FF4F4C;
        line-height: 14px;
      }
    }
  }
</style>
